import { ReactNode } from 'react';
import loginImage from '@/assets/images/login/login-side-image.png';

interface LoginLayoutProps {
  children: ReactNode;
}

export function LoginLayout({ children }: LoginLayoutProps) {
  return (
    <main className="min-h-[100dvh] overflow-hidden grid grid-cols-1 md:grid-cols-[minmax(400px,650px)_1fr]">
      {/* Left image panel: hidden on mobile, visible on tablet+ */}
      <div className="relative hidden max-h-screen md:block md:border-r-[12px] md:border-r-air-primary">
        <img src={loginImage} alt="" aria-hidden="true" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-air-primary bg-opacity-15" />
      </div>

      {/* Right content panel - 32px padding on both sides in all breakpoints */}
      <div className="relative flex flex-col justify-center items-center min-h-full px-8">
        <div className="w-full max-w-md">{children}</div>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://www.airreading.com/privacy-policy"
          className="absolute bottom-6 text-sm text-[#64748B] underline underline-offset-4 font-[16px] leading-[24px] rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          Privacy policy
        </a>
      </div>
    </main>
  );
}
